const nodeErrorMesssage = "MicroAgent should not be used in Node Environment";
const createFacade = (args, loader) => {
  let targetInstance = null;
  let buffer = [];
  let shouldBuffer = typeof window !== "undefined";
  const initialize = async () => {
    try {
      const module = await loader();
      if (module === null) {
        shouldBuffer = false;
        buffer.forEach(({ method, reject }) => {
          reject(new Error(nodeErrorMesssage));
        });
        buffer = [];
        return;
      }
      targetInstance = new module.MicroAgent(...args);
      for (const { method, args: args2, resolve, reject } of buffer) {
        try {
          const result = targetInstance[method](...args2);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      }
      buffer = [];
    } catch (error) {
      for (const { reject } of buffer) {
        reject(error);
      }
      buffer = [];
    }
  };
  const enqueueCall = (method, args2) => {
    return new Promise((resolve, reject) => {
      buffer.push({ method, args: args2, resolve, reject });
    });
  };
  if (shouldBuffer) {
    initialize();
  }
  let logNodeWarningMessage = typeof window === "undefined";
  return {
    proxyMethod(method) {
      return (...args2) => {
        if (logNodeWarningMessage) {
          console.warn(nodeErrorMesssage);
          logNodeWarningMessage = false;
        }
        if (targetInstance) {
          return Promise.resolve(targetInstance[method](...args2));
        }
        if (shouldBuffer) {
          return enqueueCall(method, args2);
        } else {
          return Promise.reject(new Error(nodeErrorMesssage));
        }
      };
    }
  };
};

export { createFacade };
